import { render, staticRenderFns } from "./awayOffice.vue?vue&type=template&id=ed2c08ec&scoped=true&"
import script from "./awayOffice.vue?vue&type=script&lang=js&"
export * from "./awayOffice.vue?vue&type=script&lang=js&"
import style0 from "./awayOffice.vue?vue&type=style&index=0&id=ed2c08ec&lang=less&scoped=true&"
import style1 from "./awayOffice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2c08ec",
  null
  
)

export default component.exports